interface Props {
  text?: string;
}

export function Spinner({ text }: Props): React.ReactNode {
  if (text)
    return (
      <article className="flex flex-col items-center gap-2.5">
        <section
          className="border-4 align-[-0.125em] text-primary inline-block h-8 w-8 animate-spin rounded-full border-solid border-current border-r-transparent motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status"
        ></section>
        <strong>{text}</strong>
      </article>
    );

  return (
    <section
      className="border-4 align-[-0.125em] inline-block h-6 w-6 animate-spin rounded-full border-solid border-current border-r-transparent motion-reduce:animate-[spin_1.5s_linear_infinite]"
      role="status"
    >
      <span className="!border-0 !absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !p-0 ![clip:rect(0,0,0,0)]">
        Loading...
      </span>
    </section>
  );
}
